










import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    spinner: () => import('./Spinner.vue')
  }
})
export default class Loading extends Vue {
  @Prop({ default: '#337ac6' }) color!: string
  @Prop({ default: 64 }) height!: number
  @Prop({ default: 64 }) width!: number
  @Prop({ default: false }) fullScreen!: boolean
}
